import { Stack } from "@vapor/react-material";
import styled from "styled-components";

export const StyledStackWithPadding = styled(Stack)`
  & > * {
    padding-top: 12px;
    padding-bottom: 12px;
  }
`;
